// NOTE: snomed.js file with all the fetches made to the SNOMED API
import {
	bloods,
	physicals,
	staticPhysicals,
	vitalSigns,
	categories
} from '../../utils/snomedConcepts'


// NOTE: get the human readable text name of a biological sex from its ID
const getBiologicalSexName = (conceptId: any) => {
	switch (conceptId) {
		case '248153007':
			return 'Male'
		case '248152002':
			return 'Female'
		case '32570691000036108':
			return 'Intersex'
		default:
			return
	}
}

// NOTE: search for a concept in a list of snomed records by its ID
const getConceptById = (conceptFamily: any, conceptId: any) =>
	conceptFamily.find((concept: any) => concept.conceptId === conceptId)

// NOTE: get a specific physical concept by ID from the physicals list
const getPhysicalById = (conceptId: any) => getConceptById(physicals, conceptId)

// NOTE: get a specific physical concept by ID from the physicals list
const getBloodById = (conceptId: any) => getConceptById(bloods, conceptId)

// NOTE: get a specific vital sign concept by ID from the vital signs list
const getVitalSignById = (conceptId: any) => getConceptById(vitalSigns, conceptId)

// NOTE: get a specific static physical (physicals that are only set once, birthday, sex and height)  concept by ID from the static physicals list
const getStaticPhysicalById = (conceptId: any) => getConceptById(staticPhysicals, conceptId)

export {
	getBiologicalSexName,
	getPhysicalById,
	getBloodById,
	getVitalSignById,
	getStaticPhysicalById,
	categories,
	physicals,
	bloods,
	vitalSigns,
	staticPhysicals
}
